import { styled } from '@mui/system';
import Rating from '@mui/material/Rating';
import Paper from '@mui/material/Paper';
import { UserIcon } from 'assets/images/icons';

export const ItemContainer = styled(Paper)({
    borderRadius: '8px !important',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '&:not(:last-child)': {
        marginBottom: '16px',
    },
});

export const MainSection = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    '@media (max-width: 1024px)': {
        padding: '16px',
    },
});

export const Footer = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderTop: '1px solid #E5E5E5',
    padding: '24px',
    '@media (max-width: 1024px)': {
        padding: '16px',
    },
});

export const HeaderRow = styled('div', {
    shouldForwardProp: prop => prop !== 'withActions',
})(({ withActions }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
    '@media (max-width: 1024px)': {
        flexDirection: 'column',
        gap: '8px',
        paddingRight: withActions ? '48px' : 0,
    },
}));

export const Actions = styled('div')({
    display: 'flex',
    '@media (max-width: 1024px)': {
        position: 'absolute',
        top: '12px',
        right: '8px',
    },
});

export const WrapperContact = styled('div')({
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
});

export const WrapperContactName = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    marginLeft: '8px',
    minWidth: 0,
    wordBreak: 'break-word',
});

export const NameRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
});

export const ChipsContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
    flexWrap: 'wrap',
});

export const CHIP_HEIGHT = 26;

export const InfoChip = styled('div', {
    shouldForwardProp: prop => prop !== 'clickable',
})(({ onClick, clickable }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    height: CHIP_HEIGHT,
    boxSizing: 'border-box',
    padding: '0 12px',
    borderRadius: '16px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.15s',
    '& svg': {
        width: '16px',
        height: '16px',
        flexShrink: 0,
    },
    ...((onClick || clickable) && {
        cursor: 'pointer',
        '&:hover, a:hover > &': {
            backgroundColor: 'var(--action-hover)',
        },
    }),
}));

export const WrapperRating = styled('div')({
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
});

export const CssRating = styled(Rating)({
    marginRight: '6px',
    '& .MuiRating-iconFilled': {
        color: '#E8A600',
    },
});

export const StyledUserIcon = styled(UserIcon)({
    width: '16px !important',
    height: '16px !important',
    '& path': {
        fill: 'var(--text-tertiary)',
        fillOpacity: 1,
    },
});
